// import { HDIR_THEME_6_1_66 } from './hdir';

export const OVERDOSEFARE_BOX_SHADOW = {
	'button-selected': '0 0 0 2px inset #002949',
	'cancel-dialog': '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
	'navbar': '0px 6px 24px 0px rgba(0, 0, 0, 0.02)',
} as const;

export const OVERDOSEFARE_COLOR = {
	black: 'black',
	blue: '#3768F6',
	brown: '#996633',
	current: 'currentColor',
	darkgray: '#504F4F',
	firebrickfour: '#A0002E',
	gold: 'gold',
	gray: 'gray',
	green: 'green',
	lightbrown: '#D2B48D',
	lightgray: '#F4F4F4',
	orange: '#FF8000',
	palegoldenrod: '#E9E4AB',
	pink: '#FF69B4',
	prussianblue: '#003057',
	purple: 'purple',
	red: '#C33232',
	transparent: 'transparent',
	turquoise: '#62F8E3',
	white: 'white',
	yellow: '#F4E21D',
} as const;

export const OVERDOSEFARE_MARGIN = {
	inherit: 'inherit',
} as const;

export const OVERDOSEFARE_MAX_WIDTH = {
	// NOTE: Yes I've hardcoded this because they are needed buildTime, serverSide and clientSide,
	// which would all require different methods to get these values.
	content: '1150px',

	text: '600px',
} as const;

// NOTE: Yes I've hardcoded these because they are needed buildTime, serverSide and clientSide,
// which would all require different methods to get these values.
export const OVERDOSEFARE_SCREENS = {
	tablet: '768px',
	desktop: '1024px',
} as const;

export const OVERDOSEFARE_THEME_6_1_66 = {
	// ...HDIR_THEME_6_1_66,
	boxShadow: OVERDOSEFARE_BOX_SHADOW, // HDIR_THEME_6_1_66 doesn't have boxShadow in theme
	extend: {
		// ...HDIR_THEME_6_1_66.extend,
		margin: OVERDOSEFARE_MARGIN,
		maxWidth: OVERDOSEFARE_MAX_WIDTH,
		screens: OVERDOSEFARE_SCREENS,
		textColor: OVERDOSEFARE_COLOR,
	},
} as const;

// export const OVERDOSEFARE_THEME = {
// 	boxShadow: OVERDOSEFARE_BOX_SHADOW,
// 	// extend: extend({
// 	// 	textColors: OVERDOSEFARE_COLOR,
// 	// }),
// 	extend: {
// 		margin: OVERDOSEFARE_MARGIN,
// 		maxWidth: OVERDOSEFARE_MAX_WIDTH,
// 		screens: OVERDOSEFARE_SCREENS,
// 		textColor: OVERDOSEFARE_COLOR,
// 	},
// } as const;
